import { render, staticRenderFns } from "./EditarCalendarioModal.vue?vue&type=template&id=2d814fc9&"
import script from "./EditarCalendarioModal.vue?vue&type=script&lang=ts&"
export * from "./EditarCalendarioModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports